import Layout from '../views/layout/Layout'

export default {
  path: '/collection',
  component: Layout,
  redirect: 'noredirect',
  name: '采集管理',
  meta: {
    title: '采集管理',
    elicon: 'el-icon-fa-cloud-download',
    roles: []
  },
  children: [
    {
      path: 'competitor',
      name: 'collection.competitor',
      component: () => import('@/views/collection/competitor'),
      meta: {
        title: '竞品管理',
        roles: [
          'material.grab.list'
        ]
      }
    },
    {
      path: 'app',
      name: 'collection.app',
      component: () => import('@/views/collection/app'),
      meta: {
        title: '应用信息管理',
        roles: [
          'system.app.list'
        ]
      }
    }
  ]
}
